export default __webpack_public_path__ + "static/media/Google.14c804f8.svg";